import { Button, Col, Row } from 'antd';
import React, { FC } from 'react';

type Props = {
  options: string[],
  value: string[],
  changes: Map<string, string[]>,
  onChange: (value: string[]) => void
};

const TagFilter: FC<Props> = ({
  options,
  changes,
  value,
  onChange,
}) => {
  const renderCheckboxes = () => options.map(field => (
    <Col
      key={JSON.stringify(field)}
    >
      <Button
        style={{ borderRadius: 6 }}
        onClick={() => {
          if (value.includes(field)) {
            onChange(value.filter(v => v !== field));
          } else {
            onChange([...value, field]);
          }
        }}
        type={value.includes(field) ? 'primary' : 'dashed'}
        size="small"
      >
        {`${field} (${changes.get(field)?.length || 0})`}
      </Button>
    </Col>
  ));

  return (
    <Row gutter={[16, 16]}>
      {renderCheckboxes()}
    </Row>
  );
};

export default TagFilter;
